import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { store } from 'redux-rest-reducer';
import { FlexView, Separator, Row } from '@cuemath/comps';
import { Header } from 'semantic-ui-react';
import { Button } from '@cuemath/comps';
import { openModal } from 'actions/modal';

import { patch as editStudent } from 'actions/students';

import {
  HeaderHead,
  Message,
  FormWrapper,
  renderFormField,
  getOptions,
  Footer,
} from 'modules/form';

import {
  FIELD_TYPES,
  studentDemoFields,
  getInputChangeMethod,
  getOnChangeMethod,
  STUDENT_TYPE,
} from 'constants/form';
import { Grid } from 'semantic-ui-react';
import COLORS from 'constants/colors';

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px 10px 0px 10px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const BasisLabelContainer = styled(Row)`
  text-decoration: underline;
  text-decoration-color: ${COLORS.LINK};
  margin: auto;
`;

const ButtonStyle = styled(Button)`
  margin-left: 10px;
`;

class StudentDemoProfile extends PureComponent {
  static defaultProps = {
    student: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      errorText: null,
      message: null,
      profilePatch: store.patch(),
      form: this.getFormDefaults(),
      formFields: this.getFormFields(),
    };

    studentDemoFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { students } = props;
    const { profilePatch } = state;
    const newProfilePatch = store.patch(students, profilePatch.id);
    const newState = {};

    // handle profile patch resolved
    if (newProfilePatch.resolved) {
      if (newProfilePatch.resolved.isPatched) {
        newState.profilePatch = newProfilePatch;
        newState.message = 'Profile details saved successfully';
      } else if (newProfilePatch.resolved.isPatchingFailed) {
        newState.profilePatch = newProfilePatch;
        newState.errorText = store.getError(newProfilePatch.resolved)
          ? store.getError(newProfilePatch.resolved).message
          : 'Error';
      }
    }

    return newState;
  }

  static propTypes = {
    actions: PropTypes.shape({
      editStudent: PropTypes.func.isRequired,
    }).isRequired,
    student: PropTypes.object,
    userConfig: PropTypes.object.isRequired,
    programs: PropTypes.array.isRequired,
  };

  getFormDefaults = () => {
    const { student } = this.props;
    const formDefaults = {};

    studentDemoFields.forEach(field => {
      formDefaults[field.name] =
        !!student && student[field.param] ? student[field.param] : field.default;
    });
    if (!student['username'])
      if (student['first_name'] && student['phone'])
        formDefaults['username'] = `${student['first_name'].trim()}.${student[
          'phone'
        ].trim()}`.toLowerCase();
    return formDefaults;
  };

  componentDidMount() {
    const { student, actions } = this.props;
    this.getFormDefaults(student);
  }

  getFormFields = () => {
    const { userConfig, programs } = this.props;

    return studentDemoFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({ field: field.name, userConfig, programs });
      return field;
    });
  };

  handlePatchAction = () => {
    const { actions, student } = this.props;
    const {
      profilePatch: { id },
      form,
      formFields,
    } = this.state;
    const data = {};

    formFields.forEach(({ name, param }) => {
      if (param && student[param] !== form[name]) {
        data[param] = form[name];
      }
      data.student_type = `${STUDENT_TYPE.STUDENT}`;
    });
    if (Object.keys(data).length) actions.editStudent(id, student.id, data);
  };

  onSubmit = event => {
    event.preventDefault();
    this.removeMessage();
    this.removeErrors();
    this.handlePatchAction();
  };

  removeMessage = () => {
    const { message } = this.state;
    if (message) this.setState(() => ({ message: null }));
  };

  removeErrors = () => {
    const { errorText } = this.state;
    if (errorText) this.setState(() => ({ errorText: null }));
  };

  onChange = (key, value) => {
    const { form } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    const stateChanges = { form: newForm };
    this.setState(() => ({ ...stateChanges }));
  };

  renderFormFields = () => {
    const { formFields, form } = this.state;
    return (
      <FlexView>
        <Grid>
          {formFields.map((field, index) => {
            field.profileView = true;
            const disabled = field.disabled || !field.editable;
            const required = false;
            const placeholder = disabled ? '' : field.label;

            return (
              <Grid.Column mobile={16} tablet={16} computer={5} key={index}>
                {renderFormField({
                  ...field,
                  profileForm: true,
                  value: form[field.name],
                  onChange: this[getInputChangeMethod(field)],
                  required,
                  disabled,
                  placeholder,
                })}
              </Grid.Column>
            );
          })}
        </Grid>
      </FlexView>
    );
  };

  renderFormHeader = () => {
    const { student } = this.props;

    if (student) {
      let fname =
        student.first_name.charAt(0).toUpperCase() + student.first_name.slice(1);
      let lname = student.last_name.charAt(0).toUpperCase() + student.last_name.slice(1);
      return (
        <HeaderHeadWrapper>
          <Header as="h3" floated="left">
            {fname} {lname} - Basic Info
          </Header>
        </HeaderHeadWrapper>
      );
    } else {
      return '';
    }
  };

  renderFormFooter = () => {
    return (
      <Footer>
        <FieldWrapper key="teachers">
          <BasisLabelContainer>
            <Button label="SAVE" onClick={this.onSubmit} />
            {/* <ButtonStyle
              label="Assign a teacher"
              renderAs="link"
              id="assign"
              onClick={this.onAssignClicked}
            /> */}
          </BasisLabelContainer>
        </FieldWrapper>
      </Footer>
    );
  };

  // onAssignClicked = studentData => {
  //   const { actions, student, programs } = this.props;

  //   actions.openModal(
  //     MODAL_FORM.ASSIGN_TEACHER,
  //     {
  //       size: 'custom',
  //       width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
  //       height: MODAL.UPDATE_HEIGHT,
  //     },
  //     {
  //       formType: FORM_ACTIONS.CREATE,
  //       data: {
  //         ...student,
  //       },
  //       programs,
  //     },
  //   );
  // };

  render() {
    const { errorText, message } = this.state;

    return (
      <FormWrapper>
        {this.renderFormHeader()}
        {message && <Message>{message}</Message>}
        <Separator transparent height="25" />
        {this.renderFormFields()}
        {errorText && <Message error={true}>{errorText}</Message>}
        <Separator transparent height="25" />
        {this.renderFormFooter()}
      </FormWrapper>
    );
  }
}

export default connect(
  ({ students }) => ({
    students,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        editStudent,
        openModal,
      },
      dispatch,
    ),
  }),
)(StudentDemoProfile);
